import { render, staticRenderFns } from "./ModalSelect.vue?vue&type=template&id=08b895cc&scoped=true"
import script from "./ModalSelect.vue?vue&type=script&lang=js"
export * from "./ModalSelect.vue?vue&type=script&lang=js"
import style0 from "./ModalSelect.vue?vue&type=style&index=0&id=08b895cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b895cc",
  null
  
)

export default component.exports